import TextField from "./TextField"
import DateField from "./DateField"
import FileField from "./FileField"
// import SliderSelectField from "./SliderSelectField"
import { RadioSelectField } from "./RadioSelectField"
import { CheckboxSelectField } from "./CheckboxSelectField"
import CheckboxField, { SwitchField } from "./CheckboxField"
import SelectField, { MultipleSelectField } from "./SelectField"
import { LargeListSelectField, MinimisedLargeListSelectField } from "./LargeListSelectField"
import FileMultipleField from "./FileMultipleField"



const Field = {
    Text: TextField,
    Date: DateField,
    
    Checkbox: CheckboxField,
    Switch: SwitchField,
    
    File: FileField,
    FileMultiple: FileMultipleField,
    Select: SelectField,
    Radio: RadioSelectField,
    // SliderSelect: SliderSelectField,
    CheckboxSelect: CheckboxSelectField,
    MultipleSelect: MultipleSelectField,
    LargeListSelect: LargeListSelectField,
    MinimisedLargeListSelect: MinimisedLargeListSelectField,
}


export default Field